export const MILLISECONDS_IN_MINUTE = 60 * 1000;
export const MILLISECONDS_IN_HOUR = 60 * MILLISECONDS_IN_MINUTE;
export const MILLISECONDS_IN_DAY = 24 * MILLISECONDS_IN_HOUR;
export const MINUTES_IN_DAY = 1440; // 1440min/day = 24hr/day * 60 min/hr
